import { resolveUrl } from "./resolve-url.js";
import { matchTag } from "./parse-attributes.js";
//#region src/media/hls/session-data.ts
/**
* Read one `#EXT-X-SESSION-DATA` tag's attributes as a {@link SessionDataEntry}, its `URI` resolved against `baseUrl`.
* `undefined` for a tag missing `DATA-ID` or carrying neither `VALUE` nor `URI`.
*/
function parseSessionData(attributes, baseUrl) {
	const dataId = attributes.get("DATA-ID");
	const value = attributes.get("VALUE");
	const uri = attributes.get("URI");
	if (!dataId || value === void 0 && uri === void 0) return void 0;
	const language = attributes.get("LANGUAGE");
	const entry = { dataId };
	if (value !== void 0) entry.value = value;
	if (uri !== void 0) {
		entry.uri = resolveUrl(uri, baseUrl);
		entry.format = attributes.get("FORMAT") === "RAW" ? "RAW" : "JSON";
	}
	if (language) entry.language = language;
	return entry;
}
/**
* The `URI` of the first `#EXT-X-SESSION-DATA` tag carrying `dataId` by reference, resolved against `baseUrl` — the
* entry `getSessionData` callers pick from a parsed presentation, read straight from playlist text for a player that
* never parses the rest. An entry carrying its datum inline as `VALUE` is skipped. Throws when the URI cannot be
* resolved, as the multivariant parser does.
*/
function findSessionDataUri(playlist, dataId, baseUrl) {
	for (const line of playlist.split(/\r?\n/)) {
		const attributes = matchTag(line.trim(), "EXT-X-SESSION-DATA");
		const entry = attributes && parseSessionData(attributes, baseUrl);
		if (entry?.dataId === dataId && entry.uri) return entry.uri;
	}
}
//#endregion
export { findSessionDataUri, parseSessionData };
